<div class="db-refund-price">
  <i class="db-icon db-icon-ds-arrow-circled"></i>
  <span>{{price}}</span>
</div>
